var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { FORM_ERROR } from 'final-form';
import { useCallback } from 'react';
import { Form as FormBase } from 'react-final-form';
import { notifyError } from '@/helpers/action';
import { logError } from '@/helpers/logger';
import { isApiValidationError } from '@/types/api/apiErrorTypes';
import { scrollToFieldErrorDom } from '@/utils/form/scroll';
import { apiValidationExceptionToSubmissionErrors } from '@/utils/validate/validate';
/**
 * * Final Formのラッパーコンポーネント
 *  * JS移行前: src/container/Ui/Common/FinalForm/FinalForm.js
 * @param props
 * @constructor
 */
export const Form = (props) => {
    const { customErrorCallback, initialValues = undefined, mutators, onSubmit: propOnSubmit, render, validate = undefined, } = props;
    const onSubmit = useCallback((values, form, callback) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield propOnSubmit(values, form, callback);
            return undefined;
        }
        catch (exception) {
            // エラーログ保存
            logError(exception);
            // 例外がバリデーションエラーか
            if (isApiValidationError(exception)) {
                // バリデーションエラーをフォーム用のエラーオブジェクトに整形
                const validationErrors = apiValidationExceptionToSubmissionErrors(exception);
                if (validationErrors) {
                    return validationErrors;
                }
            }
            if (customErrorCallback) {
                // 任意のエラーコールバックを実行
                const errorMessages = yield customErrorCallback({
                    exception,
                    form,
                    values,
                });
                if (errorMessages) {
                    return errorMessages;
                }
            }
            // デフォルトのエラートーストを表示しておく
            notifyError();
            return {
                [FORM_ERROR]: 'システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。',
            };
        }
    }), [customErrorCallback, propOnSubmit]);
    return (_jsx(FormBase, { initialValues: initialValues, mutators: mutators, onSubmit: onSubmit, render: (renderProps) => {
            const { handleSubmit: rawHandleSubmit } = renderProps, otherRenderProps = __rest(renderProps
            /**
             * submit 後にエラー要素へスクロールする処理を実行
             */
            , ["handleSubmit"]);
            /**
             * submit 後にエラー要素へスクロールする処理を実行
             */
            const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
                const returnValue = yield rawHandleSubmit(event);
                scrollToFieldErrorDom();
                return returnValue;
            });
            // eslint-disable-next-line react/jsx-no-useless-fragment
            return _jsx(_Fragment, { children: render === null || render === void 0 ? void 0 : render(Object.assign({ handleSubmit }, otherRenderProps)) });
        }, validate: validate }));
};
